import axios from 'axios'
/**
 * axios 官方文档
 * http://www.axios-js.com/zh-cn/docs/
 */
axios.defaults.withCredentials = true
export default (option) => {

    if (!option.method || option.method == "get") {
        option.params = option.data;
    }
    return new Promise((resolve, reject) => {

        axios(option).then((res) => {
            /**
             * 这里统一做res拦截
             */
            resolve(res.data)
        }).catch(() => {
            resolve(null)
        })
    });
}
